import store from '@/store'
import i18n from '@/plugins/vue-i18n'

// Category colors come from the backend as literal hex strings (e.g. "#FCEFA1"), not a fixed color enum,
// so the readable text color has to be derived rather than looked up.
export function getReadableTextColor(hex) {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex || '')
  if (!match) return '#343434'
  const [r, g, b] = [0, 2, 4].map(offset => parseInt(match[1].substr(offset, 2), 16))
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.6 ? '#343434' : '#ffffff'
}

let accessiblePartnerGroupsTotalPromise = null

// The backend already scopes the partner groups list to what the current user (admin or team leader) can access,
// so a total of 1 here means there is no ambiguity and the group name can be omitted next to a category.
export function getAccessiblePartnerGroupsTotal() {
  if (!accessiblePartnerGroupsTotalPromise) {
    accessiblePartnerGroupsTotalPromise = store
      .dispatch('PartnerGroupsModule/searchPartnerGroups', { pagination: { limit: 1, page: 1 } })
      .then(({ pagination }) => pagination?.total ?? 0)
      .catch(() => 0)
  }
  return accessiblePartnerGroupsTotalPromise
}

export function getCategoryTitle(entry) {
  return entry?.category ? entry.category.title : i18n.t('partners.category.notCategorized')
}
